module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921112651_T.a36d67ed.jpg";